module.exports = "/_next/static/images/DefineDetectValidate-68b1b3c79724ef8af6af4ac99b2a9834.webp";